"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SubscribeFormSkeleton = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@material-ui/core");
var _lab = require("@material-ui/lab");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const SubscribeFormSkeleton = () => {
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_lab.Skeleton, {
    variant: "text",
    animation: "wave",
    height: 80,
    width: "50%"
  }), /*#__PURE__*/_react.default.createElement(_core.Box, {
    mt: 5
  }, /*#__PURE__*/_react.default.createElement(_lab.Skeleton, {
    variant: "text",
    animation: "wave",
    height: 30,
    width: "90%"
  }), /*#__PURE__*/_react.default.createElement(_lab.Skeleton, {
    variant: "text",
    animation: "wave",
    height: 30
  }), /*#__PURE__*/_react.default.createElement(_lab.Skeleton, {
    variant: "text",
    animation: "wave",
    height: 30,
    width: "80%"
  })), /*#__PURE__*/_react.default.createElement(_core.Box, {
    mt: 5,
    display: "flex",
    gridGap: 20
  }, /*#__PURE__*/_react.default.createElement(_lab.Skeleton, {
    variant: "rect",
    animation: "wave",
    height: 40,
    width: 300
  }), /*#__PURE__*/_react.default.createElement(_lab.Skeleton, {
    variant: "text",
    animation: "wave",
    height: 40,
    width: 300
  })));
};
exports.SubscribeFormSkeleton = SubscribeFormSkeleton;